import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e031b9c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col no-padding" }
const _hoisted_3 = { class: "q-px-lg q-py-xl" }
const _hoisted_4 = { class: "text-h5 introduction-text text-primary" }
const _hoisted_5 = { class: "text-subtitle1 q-pt-md introduction-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.swissmedicinfo.ch",
  target: "_blank"
}, "www.swissmedicinfo.ch", -1))
const _hoisted_7 = { class: "text-body2 q-pt-xl text-bold" }
const _hoisted_8 = {
  style: {"gap":"4px"},
  class: "q-my-lg flex"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GreenTitle = _resolveComponent("GreenTitle")!
  const _component_BigCard = _resolveComponent("BigCard")!
  const _component_MainContent = _resolveComponent("MainContent")!

  return (_openBlock(), _createBlock(_component_MainContent, null, {
    default: _withCtx(() => [
      _createVNode(_component_GreenTitle, {
        class: "q-mb-md",
        title: _ctx.$t('ProductCatalog.Informations.Title')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BigCard, { url: "product-intrafix.jpg" })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("ProductCatalog.Informations.Title")), 1),
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$t("ProductCatalog.Informations.Subtitle1")), 1),
          _hoisted_6,
          _createTextVNode(_toDisplayString(_ctx.$t("ProductCatalog.Informations.Subtitle2")), 1)
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("ProductCatalog.Informations.Documentation")), 1),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brochures[_ctx.$i18n.locale] || [], (brochure, index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: {"height":"100%"},
              key: index
            }, [
              _createElementVNode("a", {
                href: _ctx.getFileFullUrl(brochure.file.url),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  class: "cursor-pointer q-mt-sm",
                  style: {"max-height":"200px","border":"1px solid lightgrey"},
                  src: _ctx.getFileFullUrl(brochure.cover.url),
                  alt: ""
                }, null, 8, _hoisted_10)
              ], 8, _hoisted_9)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}